import { Link, useLocation } from "react-router-dom";
import { REMONDIS_LOGO } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, ShieldCheck, Mail } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-4" data-testid="header-home-link">
            <img
              src={REMONDIS_LOGO}
              alt="REMONDIS"
              className="h-14 w-auto object-contain"
              data-testid="header-logo"
            />
            <div className="hidden sm:block border-l border-slate-300 pl-4">
              <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
                Anlagen-Portal
              </div>
              <div className="font-heading text-lg font-semibold text-slate-900 leading-tight">
                Updates &amp; Mitteilungen
              </div>
            </div>
          </Link>

          <nav className="flex items-center gap-3">
            {!isAdmin && (
              <Link to="/kontakt" data-testid="header-contact-link">
                <Button
                  variant="outline"
                  size="sm"
                  className="border-slate-300 text-slate-700 hover:bg-slate-50"
                >
                  <Mail className="h-4 w-4 mr-2" />
                  Kontakt
                </Button>
              </Link>
            )}
            {!isAdmin && (
              <Link to="/admin/login" data-testid="header-admin-link">
                <Button
                  variant="outline"
                  size="sm"
                  className="border-slate-300 text-slate-700 hover:bg-slate-50"
                >
                  <ShieldCheck className="h-4 w-4 mr-2" />
                  Login
                </Button>
              </Link>
            )}
            {user && user !== false && isAdmin && (
              <>
                <span className="hidden md:inline text-sm text-slate-600" data-testid="header-user-email">
                  {user.email}
                </span>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={logout}
                  className="border-slate-300 text-slate-700 hover:bg-slate-50"
                  data-testid="header-logout-button"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Abmelden
                </Button>
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}
